export default "__VITE_ASSET__BHL0dDUu__"